export var WireType;
(function (WireType) {
    WireType[WireType["Varint"] = 0] = "Varint";
    WireType[WireType["Fixed64"] = 1] = "Fixed64";
    WireType[WireType["LengthDelimited"] = 2] = "LengthDelimited";
    WireType[WireType["StartGroup"] = 3] = "StartGroup";
    WireType[WireType["EndGroup"] = 4] = "EndGroup";
    WireType[WireType["Fixed32"] = 5] = "Fixed32";
})(WireType || (WireType = {}));
